"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CallAsync;

var _AsyncComponent = _interopRequireDefault(require("customer-data-ui-utilities/component/AsyncComponent"));

var _react = _interopRequireDefault(require("react"));

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

var _ErrorBoundary = _interopRequireDefault(require("customer-data-objects-ui-components/ErrorBoundary"));

var _CommunicatorError = _interopRequireDefault(require("customer-data-communicator/components/CommunicatorError"));

var _TwilioSkeletonState = _interopRequireDefault(require("crm_ui/calling/TwilioSkeletonState"));

function requirement(done) {
  import(
  /* webpackChunkName: "profile-interactions-types-call-Call" */
  'crm_ui/components/profile/interactions/types/call/Call').then(function (mod) {
    return mod.default;
  }).then(done, (0, _AsyncComponentErrorHandler.default)('communicator-secondary'));
}

function CallAsync(props) {
  return _react.default.createElement(_ErrorBoundary.default, {
    boundaryName: "callAsync",
    ErrorComponent: _CommunicatorError.default
  }, _react.default.createElement(_AsyncComponent.default, {
    loadingContent: _react.default.createElement(_TwilioSkeletonState.default, {
      minHeight: 200
    }),
    props: props,
    requirement: requirement
  }));
}

module.exports = exports.default;